<template>
  <div class="test-form">
    <div class="edit-test-group flex flex-wrap">
      <div class="flex w-full flex-wrap justify-end">
        <vs-input
          class="w-full name-field"
          label="Test name"
          v-model="localTest.name"
        />
      </div>
      <div class="w-full mt-10">
        <label class="vs-input--label">Slug</label>
        <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
          <template slot="prepend">
            <div class="prepend-text">
              <vs-switch v-model="autoAlias" :checked="autoAlias" class="auto-alias-checkbox"/>
            </div>
          </template>

          <vs-input
            v-model="localTest.slug" 
            :disabled="autoAlias"
            class="auto-alias-field"
          />
        </vx-input-group>
      </div>
      <div class="w-full test-code-editor">
        <label class="vs-input--label">Code</label>
        <MonacoEditor
          class="pt-5 w-full monaco-editor"
          theme="vs-dark"
          height="300"
          width="600"
          :language="getCurrentExercise.language"
          v-model="localTest.code"
        ></MonacoEditor>
      </div>
      <div class="flex w-full mt-10">
        <vs-switch label="hidden" v-model="localTest.is_hidden" :checked="localTest.is_hidden" class="mr-3 test-is-hidden" />
        <label>Is hidden</label>
      </div>
      <div class="flex w-full justify-between mt-3">
        <vs-button class="save-button ml-auto mr-10" type="filled" icon-pack="feather" @click.stop="finishAndClose">Save</vs-button>
        <vs-button class="save-button" color="primary" type="border" icon-pack="feather" @click.stop="onClose">Cancel</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import slug from 'slug-generator'
import MonacoEditor from 'monaco-editor-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    MonacoEditor
  },
  props: {
    test: Object,
    onClose: {
      type: Function,
      required: true
    },
  },
  data: () => {
    return {
      localTest: {},
      autoAlias: true,
    }
  },
  computed: {
    ...mapGetters('exercises', ['getCurrentExercise']),
  },
  methods: {
    finishAndClose () {
      this.$emit('finish-edit-test', {
        ...this.localTest
      })
    }
  },
  watch: {
    'localTest.name': function (newValue) {
      if (this.autoAlias) {
        this.localTest.slug = slug(newValue)
      }
    },
    'autoAlias': function (newValue) {
      if (newValue) {
        this.localTest.slug = slug(this.localTest.name)
      }
    },
  },
  mounted() {
    if (this.test) {
      this.localTest = {...this.test}
    }
  }
}
</script>
